module.exports = __webpack_public_path__ + "f570f893304a34739da6d95106b3a2d5.MP3";